<ng-container>
  <section class="business-good-point-swiper">
    <!-- topic -->
    <div class="topic">
      <ng-container *ngFor="let item of mockContent">
        <div class="title" [innerHTML]="item.title | translate"></div>
        <div class="heading-detail">{{ item.detail | translate }}</div>
      </ng-container>
      <div class="tab-list desktop">
        <div class="box__btn-container mobile">
          <button (click)="actionClickSlide('prev')" aria-label="previous-slide"
            ><i class="fas fa-arrow-left"></i
          ></button>
        </div>

        <!-- TAB -->
        <ng-container *ngFor="let item of goodPointList; let index = index">
          <div class="item" [ngClass]="{ active: currentSlide === index + 1 }" (click)="goToSlide(index + 1)">{{
            'BUSINESS_REGISTRATION.BUSINESS_SWIPER.MENU_BAR.' + (index + 1) | translate
          }}</div>
        </ng-container>

        <div class="box__btn-container mobile">
          <button (click)="actionClickSlide('next')" aria-label="next-slide"><i class="fas fa-arrow-right"></i></button>
        </div>
      </div>

      <div class="tab-list mobile">
        <div class="box__btn-container mobile">
          <button (click)="actionClickSlide('prev')" aria-label="previous-slide"
            ><i class="fas fa-arrow-left"></i
          ></button>
        </div>
        <ng-container *ngFor="let item of goodPointList; let index = index">
          <div
            *ngIf="currentSlide === index + 1"
            class="item"
            [ngClass]="{ active: currentSlide === index + 1 }"
            (click)="goToSlide(index + 1)"
          >
            {{ 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.MENU_BAR.' + (index + 1) | translate }}</div
          >
        </ng-container>

        <div class="box__btn-container mobile">
          <button (click)="actionClickSlide('next')" aria-label="next-slide"><i class="fas fa-arrow-right"></i></button>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="box__btn-container desktop">
        <button (click)="actionClickSlide('prev')" aria-label="previous-slide"
          ><i class="fas fa-arrow-left"></i
        ></button>
      </div>

      <div class="box__content">
        <ng-container *ngFor="let item of goodPointList; let index = index">
          <div class="box__item" *ngIf="index + 1 === currentSlide" [ngClass]="displaySlideClass(index + 1)">
            <div class="box__left">
              <div class="box__text">
                <div class="box__text--title" [innerHTML]="item.title | translate"> </div>
                <div class="box__text--description" [innerHTML]="item.description | translate"> </div>
                <a
                  *ngIf="item.readMore"
                  href="{{ item.readMore }}"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="box__text--link"
                  ><span>{{ 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.LEARN_MORE' | translate }}</span
                  ><i class="fas fa-angle-right"></i>
                </a>
              </div>
            </div>

            <div class="box__right">
              <div class="box__video">
                <picture>
                  <source srcset="{{ item.imgWebp }}" type="image/webp" />
                  <source srcset="{{ item.img }}" type="image/png" />
                  <img
                    src="{{ item.img }}"
                    width="300"
                    height="auto"
                    loading="lazy"
                    class="box__video--img-cover"
                    alt="{{ item.alt | translate }}"
                    title="{{ item.alt | translate }}"
                  />
                </picture>
              </div>
            </div>
          </div>

          <div class="dot-wrapper" *ngIf="index + 1 === currentSlide">
            <ng-container *ngFor="let item of goodPointList; let index = index">
              <div class="dot" [ngClass]="{ active: index + 1 === currentSlide }"></div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <div class="box__btn-container desktop">
        <button (click)="actionClickSlide('next')" aria-label="next-slide"><i class="fas fa-arrow-right"></i></button>
      </div>
    </div>
  </section>
</ng-container>
